import styles from './DomainCaptureSection.module.scss'

import { DOMAIN_CAPTURE_DOCS_URL } from '@/constants/enterprise'
import { useHasDepartments } from '@/hooks/useHasDepartments'
import DomainVerificationSection from '@/pages/app/Settings/components/DomainVerification'

const DomainCaptureSection = () => {
  const hasDepts = useHasDepartments()
  return (
  <div className={styles.section}>
    <div className={styles.info}>
      <div className={styles.title}>
        Domain capture <span className={styles.optional}>(Optional)</span>
      </div>
      <div className={styles.description}>
        Verify your company&rsquo;s domain(s) with Wispr Flow. This allows you to require that users with your
        company&rsquo;s domain only use Flow if they&rsquo;ve joined your {hasDepts ? 'organization' : 'team'}.
        <br />
        <br />
        <strong> This is an optional feature. </strong> You and your teammates can continue to use Wispr Flow without
        verifying your domain.
        <p className={styles.docs}>
          <a href={DOMAIN_CAPTURE_DOCS_URL} target="_blank" rel="noopener noreferrer">
            Learn more about how domain verification works.
          </a>
        </p>
      </div>
    </div>

    <div className={styles.subsection}>
      <DomainVerificationSection />
    </div>
  </div>
  )
}

export default DomainCaptureSection
